import { createContext, useContext } from "react"
import useDiscoveryTemplate from "../hooks/useDiscoveryTemplate"

const DiscoveryTemplateContext = createContext(null)

export const DiscoveryTemplateProvider = ({ children }) => {

    const value = useDiscoveryTemplate()

    return (
        <DiscoveryTemplateContext.Provider value={value}>
            {children}
        </DiscoveryTemplateContext.Provider>
    )
}

export const useDiscoveryTemplateContext = () => useContext(DiscoveryTemplateContext) ?? {}
